import React from 'react';
import { Box } from 'reactjs-admin-lte';
import TooltipIconButton from 'components/core/TooltipIconButton';
import DocumentTable from 'components/documents/DocumentTable';


const Reference = (props) => {
  
  const {
    title,
    documents,
    showUploadModal,
    handleRemove,
    handleDownload
  } = props;
  
  return (
    <Box className="box-widget">
      <Box.Header border={true}>
        <Box.Title>{title}</Box.Title>
        <Box.Tools>
          <TooltipIconButton
            id="upload-new-reference"
            className="btn-box-tool"
            icon="upload"
            description="Upload Reference"
            onClick={showUploadModal} />
          <Box.CollapsedToggleButton />
        </Box.Tools>
      </Box.Header>
      <Box.Body noPadding={true}>
        <DocumentTable
          documents={documents}
          removable={true}
          handleRemove={handleRemove}
          handleDownload={handleDownload} />
      </Box.Body>
    </Box>
  );
}


Reference.defaultProps = {
  title: 'Job Specific References'
}

export default Reference;
